import {Inject, Injectable, Injector} from '@angular/core';
import { LogFields } from './log-data.interface';
import { Logger } from './logger';
import { environment } from 'environments/environment';
import { LogLevel } from './log-level.enum';
import {AuthenticatedUserService} from '../service/authenticated-user.service';
import {PlatformLocation} from '@angular/common';
import {Router} from '@angular/router';
import {TokenService} from '@app/core/security/token.service';

@Injectable({
    providedIn: 'root'
})
export class LogService {
    private logger: Logger;

    constructor(@Inject(Injector) private injector: Injector,
                private authenticatedUserService: AuthenticatedUserService,
                private tokenService: TokenService) {
        this.logger = new Logger(environment.customer.appTitle, environment.log.serverLoggingUrl, tokenService);
    }

    private get platformLocation() {
        return this.injector.get(PlatformLocation);
    }

    private get router() {
        return this.injector.get(Router);
    }

    private logHttpRequest(level: LogLevel, msg: any, elapsedTime: number, requestPath: string, status: number) {
        // const url = this.platformLocation.location ? this.platformLocation.location.href : window.location.href;
        const url = this.router instanceof Router ? this.router.url : '';
        const username = this.authenticatedUserService.authenticatedUser ? this.authenticatedUserService.authenticatedUser.username : '';
        const userRole = this.authenticatedUserService.authenticatedUser ? this.authenticatedUserService.authenticatedUser.role : '';

        const logFields: LogFields = {
            environment: environment.datahubBaseURI,
            appVersion: environment.version,
            username,
            userRole,
            requestPath,
            elapsedTime,
            status,
            url
        };

        this.logger.log(level, `${msg}`, logFields);
    }

    public logHttpTrace(info: any, elapsedTime: number, requestPath: string, status: number) {
        this.logHttpRequest(LogLevel.TRACE, info, elapsedTime, requestPath, status);
    }

    public logHttpError(errorMsg: any, elapsedTime: number, requestPath: string, status: number) {
        this.logHttpRequest(LogLevel.ERROR, errorMsg, elapsedTime, requestPath, status);
    }

    private log(level: LogLevel, msg: string) {
        // const url = this.platformLocation.location ? this.platformLocation.location.href : window.location.href;
        const url = this.router instanceof Router ? this.router.url : '';
        const username = this.authenticatedUserService.authenticatedUser ? this.authenticatedUserService.authenticatedUser.username : '';
        const userRole = this.authenticatedUserService.authenticatedUser ? this.authenticatedUserService.authenticatedUser.role : '';

        const logFields: LogFields = {
            environment: environment.datahubBaseURI,
            appVersion: environment.version,
            username,
            userRole,
            requestPath: '',
            elapsedTime: 0,
            status: 0,
            url: url
        };

        this.logger.log(level, msg, logFields);
    }

    public logDebug(msg: string) {
        this.log(LogLevel.DEBUG, msg);
    }

    public logInfo(info: string) {
        this.log(LogLevel.INFO, info);
    }

    public logWarn(warnMsg: string) {
        this.log(LogLevel.WARN, warnMsg);
    }

    public logError(errorMsg: string) {
        this.log(LogLevel.ERROR, errorMsg);
    }

    public logFatal(errorMsg: string) {
        this.log(LogLevel.FATAL, errorMsg);
    }
}
